import { forEach } from "lodash";

import * as actionType from "../actions/actionType";

import { subSystemMap } from "../config/subSystemMenuConfig";

import my1 from "@/assets/image/my1.png";
import my2 from "@/assets/image/my2.png";
const makeMenuList = (userMenuList) => {
  const cookedList = [];
  forEach(userMenuList, (m) => {
    if (m.type === 1 || m.type === 3) {
      cookedList.push({
        ...m,
        component: subSystemMap[m.component],
        title: m.name,
        authInfo: m.children && m.children.length ? m.children : m.tabMenus,
        subMenu:
          m.children && m.children.length ? makeMenuList(m.children) : [],
      });
    }
  });

  return cookedList;
};

const initialState = {
  systemLoading: false,

  userName: "",
  userId: "",
  type: [],
  invitationCode: "",
  menuList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Update user info
    case actionType.UPDATE_USER_INFO:
      return {
        ...state,
        ...action.payload,
      };

    // Update menu list
    case actionType.UPDATE_MENU_LIST:
      return {
        ...state,
        menuList: makeMenuList(action.payload.menuList),
      };

    // Toggle system loading
    case actionType.TOGGLE_SYSTEM_LOADING:
      return {
        ...state,
        systemLoading: action.payload.status,
      };

    default:
      return state;
  }
};
